import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { UserContentMenuOption } from 'src/app/components/rides-places/models/user-content-menu-options';
import { SelectedItems } from 'src/app/models/selectedItems';

@Component({
    imports: [AngularSvgIconModule, NgClass],
    selector: 'rdx-user-content-menu',
    styleUrls: ['./user-content-menu.component.scss'],
    templateUrl: './user-content-menu.component.html',
})
export class UserContentMenuComponent implements OnInit {
    @Input() showRecentContent = false;
    @Input() showGeofences = false;
    @Input() selectedItems: SelectedItems;

    @Output() tabSelected = new EventEmitter<UserContentMenuOption>();

    currentTab: UserContentMenuOption;
    navigationTabs = UserContentMenuOption;

    ngOnInit(): void {
        if (this.showRecentContent) {
            this.currentTab = UserContentMenuOption.recent;
        } else {
            this.currentTab = UserContentMenuOption.trackedRides;
        }
    }

    selectRecent(): void {
        this.currentTab = UserContentMenuOption.recent;
        this.tabSelected.emit(this.currentTab);
    }

    selectTrackedRides(): void {
        this.currentTab = UserContentMenuOption.trackedRides;
        this.tabSelected.emit(this.currentTab);
    }

    selectWaypoints(): void {
        this.currentTab = UserContentMenuOption.waypoints;
        this.tabSelected.emit(this.currentTab);
    }

    selectPlannedRides(): void {
        this.currentTab = UserContentMenuOption.plannedRides;
        this.tabSelected.emit(this.currentTab);
    }

    selectGeofences(): void {
        this.currentTab = UserContentMenuOption.geofences;
        this.tabSelected.emit(this.currentTab);
    }

    selectCollections(): void {
        this.currentTab = UserContentMenuOption.collections;
        this.tabSelected.emit(this.currentTab);
    }
}
